import { motion } from "framer-motion";

const NODES = [
    {
        day: "Born",
        date: "Aug 5, 1993",
        title: "Danielle Cathleen Alvarez.",
        note: "Born at Long Island Jewish Hospital — delayed at birth, deprived of oxygen at the hands of the doctors. Twenty-eight years later, another hospital would finish what the first had started. Bright. Kind. Loved.",
    },
    {
        day: "Day 1",
        date: "Aug 27, 2021",
        title: "Admitted to Northwell Glen Cove.",
        note: "Eight minutes from home. They said Danielle could come home in two days. That was the promise.",
    },
    {
        day: "Day 6",
        date: "Sep 1, 2021",
        title: "\u201CGo take a shower.\u201D",
        note: "They told Rebecca she could go home and shower — and come right back. That was a lie. Once she was gone, all communication was blocked. Danielle was tied to the bed, scared and fighting.",
    },
    {
        day: "Day 6 → 41",
        date: "Aug–Oct 2021",
        title: "Two days became forty-one.",
        note: "The two-day promise became forty-one days of hell. Rebecca was barred from the room. Danielle was sedated on a ventilator, unable to speak for herself.",
    },
    {
        day: "Day 41",
        date: "Oct 6, 2021",
        title: "She is gone.",
        note: "Thirty-two days on the ventilator. Forty-one days in their care.",
    },
];

export default function Timeline() {
    return (
        <section
            data-testid="timeline-section"
            className="relative w-full bg-[color:var(--surface)] py-24 sm:py-32 border-y border-neutral-300"
            id="timeline"
        >
            <div className="max-w-[92rem] mx-auto px-6 sm:px-12 lg:px-16">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-10%" }}
                    transition={{ duration: 1 }}
                    className="grid grid-cols-12 mb-16 sm:mb-24"
                >
                    <div className="col-span-12 sm:col-span-3 font-sans text-[10px] uppercase tracking-[0.35em] text-neutral-500">
                        Chapter III — The Record
                    </div>
                    <div className="col-span-12 sm:col-span-9 mt-3 sm:mt-0">
                        <h2 className="font-serif text-5xl sm:text-7xl lg:text-8xl leading-[0.9] tracking-tight text-neutral-950">
                            The forty-one days,
                            <br />
                            <span className="italic font-light">counted plainly.</span>
                        </h2>
                    </div>
                </motion.div>

                <div className="relative grid grid-cols-12 gap-6 sm:gap-10">
                    {/* Vertical line */}
                    <div className="hidden sm:block absolute left-[calc(25%+0.75rem)] top-2 bottom-2 w-px bg-neutral-400/80" />

                    <div className="col-span-12 sm:col-start-2 sm:col-span-10 space-y-16 sm:space-y-20">
                        {NODES.map((n, i) => (
                            <motion.div
                                key={n.day}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-15%" }}
                                transition={{
                                    duration: 1,
                                    delay: i * 0.08,
                                    ease: [0.22, 1, 0.36, 1],
                                }}
                                className="grid grid-cols-12 gap-6 items-start relative"
                                data-testid={`timeline-node-${i}`}
                            >
                                {/* Node dot */}
                                <div className="hidden sm:block col-span-1 relative">
                                    <span className="absolute right-0 top-2 w-2.5 h-2.5 bg-neutral-900 -mr-[5px]" />
                                </div>

                                <div className="col-span-4 sm:col-span-3 pl-0 sm:pl-8">
                                    <div className="font-sans tabular text-3xl sm:text-5xl font-light leading-none text-neutral-950">
                                        {n.day}
                                    </div>
                                    <div className="mt-2 font-sans text-[10px] uppercase tracking-[0.3em] text-neutral-500 tabular">
                                        {n.date}
                                    </div>
                                </div>
                                <div className="col-span-8 sm:col-span-8">
                                    <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-neutral-950">
                                        {n.title}
                                    </h3>
                                    <p className="mt-4 max-w-xl font-serif text-lg sm:text-xl leading-relaxed text-neutral-700">
                                        {n.note}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
